import {Constructor} from "../../global/constructor"
import FormElementRevive from "../models/revive/formElementRevive"
import ConditionalRuleSetRevive from "../models/revive/conditionalRuleSetRevive"
import FormSubmissionStepRevive from "~/models/revive/formSubmissionStepRevive"

export default class ReviveFactory {
  /**
   * Use as the "reviver" function of +JSON.parse+
   */
  static reviver(this: any, key: string, value: any): any {
    let reviveValue: any = value
    let reviveKlass: Constructor

    if (value?._type?.startsWith('FormElements::')) {
      reviveKlass = FormElementRevive
    } else if (value?._type === 'ConditionalRules::ConditionalRuleSet') {
      reviveKlass = ConditionalRuleSetRevive
    } else if (value?._type?.startsWith('FormSubmissionSteps::')) {
      reviveKlass = FormSubmissionStepRevive
    }
    if (reviveKlass) reviveValue = ReviveFactory.revive(reviveKlass, value)

    return reviveValue
  }

  /**
   * Simple wrapper for creating instance and assign values to it
   */
  static revive<T>(klass: Constructor<T>, value: Partial<T>): T {
    const instance = new klass()
    Object.assign(instance, value)
    return instance
  }
}